import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(private translate: TranslateService) {
        translate.addLangs(['en', 'fr', 'ur', 'es', 'it', 'fa', 'br']);
        translate.setDefaultLang('br');
        const browserLang = translate.getBrowserLang();
        translate.use(
            browserLang.match(/en|fr|ur|es|it|fa|br/) ? browserLang : 'br'
        );
    }

    ngOnInit() {}
}
